import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const PriceIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={12} cy={12} r={9.5} stroke="currentColor" />
            <path
                d="M14.3865 8.77003C14.0926 8.45389 13.259 7.83094 12.2757 7.86831C11.0467 7.91501 9.35962 8.46099 9.06062 11.3864C8.76161 14.3118 10.1834 15.8391 11.7754 16.0897C13.049 16.2901 13.8118 15.7583 14.37 15.3139"
                stroke="currentColor"
            />
            <path d="M7.61353 11.0874H13.3431" stroke="currentColor" />
            <path d="M7.6297 12.8411H12.6077" stroke="currentColor" />
        </svg>
    </IconWrapper>
)
